import React from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser } from "@fortawesome/sharp-light-svg-icons"

const LOGIN_LINK = "https://ro-group.my.site.com/identity/SelfRegister"

const UserLink = ({ mobileVersion }) => {
  const { t } = useTranslation()

  return (
    <Link
      className="flex w-full py-3 pl-4 pr-0 btn hover:bg-ro-gray-75 md:block md:w-12 md:h-12 md:px-0 md:py-0 md:active:border-b md:hover:bg-ro-gray-100 md:hover:border-b-ro-gray-100 md:active:bg-ro-gray-200"
      link={LOGIN_LINK}
    >
      {mobileVersion && <span>{t("generic.login")}&nbsp;</span>}
      <div className="flex items-center justify-center w-12 h-6 ml-auto md:h-12 md:ml-0">
        <FontAwesomeIcon icon={faUser} size="1x" className="inline-block" />
      </div>
    </Link>
  )
}

export default UserLink
